import "./index.css";
// src/WebSearchToken/WebSearchToken.tsx
import Icon from "@cloudscape-design/components/icon";
import Link from "@cloudscape-design/components/link";

// src/WebSearchToken/WebSearchToken.module.scss
var WebSearchToken_module_default = {
  token: "WebSearchToken_module_token",
  iconWrapper: "WebSearchToken_module_iconWrapper",
  tokenContent: "WebSearchToken_module_tokenContent",
  tokenLabel: "WebSearchToken_module_tokenLabel",
  tokenTitle: "WebSearchToken_module_tokenTitle",
  tokenSummary: "WebSearchToken_module_tokenSummary"
};

// src/WebSearchToken/WebSearchToken.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var WebSearchToken = ({ card }) => {
  return /* @__PURE__ */ jsxs("div", { className: WebSearchToken_module_default.token, children: [
    /* @__PURE__ */ jsx("span", { className: WebSearchToken_module_default.iconWrapper, children: /* @__PURE__ */ jsx(Icon, { name: "globe", className: WebSearchToken_module_default.tokenIcon }) }),
    /* @__PURE__ */ jsxs("div", { className: WebSearchToken_module_default.tokenContent, children: [
      /* @__PURE__ */ jsx("div", { className: WebSearchToken_module_default.tokenLabel, children: /* @__PURE__ */ jsx(Link, { external: true, href: card.url, fontSize: "inherit", children: card.name }) }),
      /* @__PURE__ */ jsx("div", { className: WebSearchToken_module_default.tokenTitle, children: card.title }),
      /* @__PURE__ */ jsx("div", { className: WebSearchToken_module_default.tokenSummary, children: card.summary })
    ] })
  ] });
};
export {
  WebSearchToken
};
//# sourceMappingURL=index.js.map
